import { useEffect } from 'react'

import { registerMicroAppInIframe } from 'components/apps/fullscreen/microApp/registerMicroAppInIframe'
import { MICRO_APP_DOM_ELEMENT_ID } from 'constants/apps'
import { useAppsContext } from 'providers/apps/AppsContext'
import { SystemAppCode } from 'types/apps/microApps'
import { MicroIframeAppConfig } from 'types/common/singleSpa'
import { NativeMicroAppData } from 'types/osState/appDataResolved'
import { getActiveWhen } from 'utils/apps'
import { registerMicroApp } from 'utils/singleSpa'

interface Props {
  appData: NativeMicroAppData
}

export const FullscreenMicroApp = ({ appData }: Props) => {
  const { getFullPageAppProps, setIsFullscreenMicroAppActive } = useAppsContext()
  const { app, currentBaseUrl } = appData
  const { stableId, libraryType, bundleUrl, windowLibraryName } = app
  const isFirstPartyApp = Object.values(SystemAppCode).includes(app.stableId as SystemAppCode)

  useEffect(() => {
    const microAppConfig = {
      stableId,
      libraryType,
      windowLibraryName,
      bundleUrl,
      ...(!isFirstPartyApp ? { currentBaseUrl } : {}),
      domElementId: MICRO_APP_DOM_ELEMENT_ID,
      activeWhen: getActiveWhen(app),
      customProps: getFullPageAppProps({ stableId }),
    }
    !isFirstPartyApp
      ? registerMicroAppInIframe(microAppConfig as MicroIframeAppConfig)
      : registerMicroApp(microAppConfig)
  }, [app, isFirstPartyApp, currentBaseUrl, stableId, libraryType, bundleUrl, windowLibraryName, getFullPageAppProps])

  useEffect(() => {
    setIsFullscreenMicroAppActive(true)

    return () => setIsFullscreenMicroAppActive(false)
  }, [setIsFullscreenMicroAppActive])

  return null
}
